import { Matrix3, Matrix4, Vector3 } from "three";

export function validLightEstimate(estimate) {
  const sh = estimate?.sphericalHarmonicsCoefficients;
  const rgb = estimate?.primaryLightIntensity;
  const direction = estimate?.primaryLightDirection;
  return sh?.length === 27 && Array.from(sh).every(Number.isFinite) &&
    [rgb?.x, rgb?.y, rgb?.z].every(n => Number.isFinite(n) && n >= 0) &&
    [direction?.x, direction?.y, direction?.z].every(Number.isFinite) &&
    Math.hypot(direction.x, direction.y, direction.z) > 0.001;
}

// Rotate the l=1 vector and l=2 symmetric traceless tensor. Parenting a Three
// LightProbe does NOT rotate its SH coefficients. Translation must not affect light.
export function rotateLightHarmonics(source, rotation, target) {
  const r = new Matrix3().setFromMatrix4(new Matrix4().makeRotationFromQuaternion(rotation));
  const inverse = r.clone().transpose();
  const vector = new Vector3();
  const tensor = new Matrix3();
  for (let color = 0; color < 3; color++) {
    const c = i => source[i * 3 + color];
    const put = (i, value) => target.coefficients[i].setComponent(color, value);
    put(0, c(0));
    vector.set(c(3), c(1), c(2)).applyMatrix3(r);
    put(3, vector.x); put(1, vector.y); put(2, vector.z);
    tensor.set(
      -0.315392*c(6)+0.546274*c(8), 0.546274*c(4), 0.546274*c(7),
      0.546274*c(4), -0.315392*c(6)-0.546274*c(8), 0.546274*c(5),
      0.546274*c(7), 0.546274*c(5), 0.630784*c(6)
    ).premultiply(r).multiply(inverse);
    const e = tensor.elements;
    put(4, e[3]/0.546274); put(5, e[7]/0.546274); put(7, e[6]/0.546274);
    put(6, e[8]/0.630784); put(8, (e[0]-e[4])/1.092548);
  }
  return target;
}

export function supportsContactShadow(blendMode) {
  // An additive display cannot subtract light from the physical room.
  return blendMode !== "additive";
}
